import type { Role } from '@bekebi/domain';

/**
 * Human-facing role names. The internal role values stay as the API and database define them;
 * only the label shown to people differs. John's role is stored as `operations` and is called
 * "ICT" everywhere in the portal (director decision, Phase 05).
 */
export const ROLE_LABELS: Record<Role, string> = {
  admin: 'Admin',
  operations: 'ICT',
};

export function roleLabel(role: Role): string {
  return ROLE_LABELS[role];
}
